import { ShieldAlertIcon } from './ShieldAlertIcon';

/**
 * author: Peter Noble
 * id B5DC36AC-6F79-4CDE-B1CD-02F221BF8CE4
 * name shield-alert
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-alert.svg
 * tags
 * - Alert / Error 
 */
export const ShieldWarningIcon = ShieldAlertIcon;
export default ShieldWarningIcon